// extracted by mini-css-extract-plugin
export default {"badge":"styles_badge__Saoom","active":"styles_active__hvqza"};